module.exports = __webpack_public_path__ + "img/RMR Logo White.3704bd5f.png";